import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  authActions,
  loginAuthentication,
  setModelShow,
  userRegister,
  validatePhoneNumber,
} from "../../redux/athentication/Athentication";

const RegisterOtp = (props) => {
  const { otp } = useSelector((state) => state.Athentication);
  console.log(otp);
  const dispatch = useDispatch();

  const [otpValue, setOtpValue] = useState("");
  const [userdata, setUserdata] = useState("");
  const [timeShow, setTimeShow] = useState(false);
  const [timer, setTimer] = useState(30);
  const [btnLoading, setBtnLoading] = useState(false);

  useEffect(() => {
    const formdata = props.formData;
    setUserdata(formdata);
  }, [props.formData]);

  const OtpChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    setOtpValue(value);
  };

  const resendClick = () => {
    setTimeShow(true);
    const formdata = {
      mobile: userdata.mobile,
      OTP: otp,
    };
    dispatch(loginAuthentication(formdata));
  };

  useEffect(() => {
    const counter = timer > 0 && setInterval(() => setTimer(timer - 1), 1000);
    return () => clearInterval(counter);
  }, [timer]);

  const handleSubmit = async () => {
    setBtnLoading(true);
    try {
      if (otpValue.length === 6) {
        if (otpValue === otp) {
          const validateNumber = await dispatch(
            validatePhoneNumber(userdata.mobile)
          );
          if (validateNumber.payload.success === true) {
            const userData = validateNumber.payload.user;
            const authenticForm = {
              ...userData,
              isAuth: true,
            };
            dispatch(authActions.signIn(authenticForm));
            dispatch(setModelShow(false));
          } else {
            const formdata = {
              name: userdata.name,
              email: userdata.email,
              mobile: userdata.mobile,
            };

            const userDetails = await dispatch(userRegister(formdata));

            if (userDetails.payload.success === true) {
              const userData = userDetails.payload.user;
              const authenticForm = {
                ...userData,
                isAuth: true,
              };
              dispatch(authActions.signIn(authenticForm));
              setBtnLoading(false);
              dispatch(setModelShow(false));
              window.location.reload(false);
            }
          }
        } else {
        }
      } else {
      }
    } catch (error) {}
  };
  return (
    <>
      <div className="custom-form">
        <div name="Otpform">
          <label>
            Verify Otp *
            <span className="dec-icon">
              <i className="fal fa-user" />
            </span>
          </label>
          <input
            name="email"
            type="text"
            placeholder="Enter Otp"
            required
            minLength={6}
            maxLength={6}
            value={otpValue}
            onChange={(e) => OtpChange(e)}
          />
          {timer > 0 ? (
            <>
              <div className="lost_password">
                <a>Resend OTP again in 0:{timer} secs</a>
              </div>
            </>
          ) : (
            <>
              <div className="lost_password" onClick={() => resendClick()}>
                <a>Resend Otp</a>
              </div>
            </>
          )}

          <div className="filter-tags">
            <input id="check-a3" type="checkbox" name="check" />
            <label htmlFor="check-a3">Remember me</label>
          </div>
          <div className="clearfix" />
          {btnLoading === true ? (
            <>
              <button className="log_btn color-bg" onClick={handleSubmit}>
                Logining you...
              </button>
            </>
          ) : (
            <>
              <button className="log_btn color-bg" onClick={handleSubmit}>
                Login
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default RegisterOtp;
